import { render, staticRenderFns } from "./lowerLimbs.vue?vue&type=template&id=6db10432&scoped=true&"
import script from "./lowerLimbs.vue?vue&type=script&lang=js&"
export * from "./lowerLimbs.vue?vue&type=script&lang=js&"
import style0 from "./lowerLimbs.vue?vue&type=style&index=0&id=6db10432&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db10432",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\200xth\\xth2.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6db10432')) {
      api.createRecord('6db10432', component.options)
    } else {
      api.reload('6db10432', component.options)
    }
    module.hot.accept("./lowerLimbs.vue?vue&type=template&id=6db10432&scoped=true&", function () {
      api.rerender('6db10432', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/traning/lowerLimbs.vue"
export default component.exports